import { render, staticRenderFns } from "./InventoryTitleCaptureDetail.vue?vue&type=template&id=1cc67a30&scoped=true"
import script from "./InventoryTitleCaptureDetail.vue?vue&type=script&lang=js"
export * from "./InventoryTitleCaptureDetail.vue?vue&type=script&lang=js"
import "./InventoryTitleCaptureDetail.vue?vue&type=style&index=0&id=1cc67a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc67a30",
  null
  
)

export default component.exports